import React, { useEffect, useRef, useState } from "react";
import styles from "../CattleModal/CattleModal.module.css"
import CloseIcon from "@mui/icons-material/Close";
import SingleDocModal from "../../../../Borrower/BorrowerDetails/Components/Modals/SingleDocModal";
import { url } from "../../../../../App";
import axios from "axios";
import Cookies from "js-cookie";
import PdfInsurance from "../PDFInsurance/PdfInsurance"
import { ToastContainer,toast } from "react-toastify";
import { MdDeleteForever } from "react-icons/md";
import { FaImage } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

const PropertyModal = ({ loanId, closeModal }) => {
  const [open, setOpen] = React.useState(false);
  const [propertyVal, setPropertyVal] = useState({
    srNo:"",
    propertyNumber:"",
    sumAssured:"",
    policyNumber:"",
    propertyAddress:"",
    imageFormat: "",
    imageBase64: "",
  });

  const [docModalProps, setDocModalProps] = useState({
    doc: "",
    format: "",
  });

  const [docModal, setDocModal] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);
  const [propertyCount, setPropertyCount] = useState(1);
  const [propertyArr, setPropertyArr] = useState([]);
  const [isUpdateActive, setIsUpdateActive] = useState(false);

  const fetchData = async () => {
    setOpen(true);
    const req = {
      loanId: loanId,
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
    };
    try {
      const { data } = await axios.post(url + "/loan/view/property/data", req);
      if (!data.auth) {
        setOpen(false);
        if (data.message === "No data found.") {
          setPropertyArr([]);
          setPropertyCount("1")
        }
        return;
      }
      setPropertyCount(data.propertyCount);
      setPropertyArr(data.data);
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.log(error.response.status);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const uploadRef = useRef(null);

  const handleInputChange = (state) => {
    return (e) => {
      setPropertyVal((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    console.log(doc_type)
    if (doc_type !== "pdf" && doc_type !== "xlsx") {
      setOpen(false);
      toast.error(
      "Please upload Property Insurance Documents in Pdf or Excel format only.");
      return;
    }

    setPropertyVal((prevState) => ({
      ...prevState,
      imageFormat: file.name.split(".")[1],
    }));
    const reader = new FileReader();

    reader.onload = () => {
      const base64string = reader.result.split(",")[1];
      setPropertyVal((prevState) => ({
        ...prevState,
        imageBase64: base64string,
      }));
    };
    reader.readAsDataURL(file);
    toast.success("Document Uploaded Successfully.")
  };

  const initialPropertyState = {
    srNo:"",
    propertyNumber:"",
    sumAssured:"",
    policyNumber:"",
    propertyAddress:"",
    imageFormat: "",
    imageBase64: "",
  };

  const addFieldHandler = async () => {
    setOpen(true);
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId: loanId,
      srNo: isUpdateActive ? propertyVal.srNo : propertyCount,
      propertyNumber: propertyVal.propertyNumber,
      sumAssured: propertyVal.sumAssured,
      policyNumber: propertyVal.policyNumber,
      propertyAddress: propertyVal.propertyAddress,
      docType: propertyVal.imageFormat,
      chequeData: propertyVal.imageBase64,
    };
    try {
      let res;
      if (isUpdateActive) {
        res = await axios.post(url + "/loan/update/property/data", request);
      } else {
        res = await axios.post(url + "/loan/add/property/data", request);
      }
  
      if (res.data.auth === true) {
        setOpen(false);
        toast.success(res.data.message);
      } else {
        setOpen(false);
        toast.error(res.data.message);
      }
      await fetchData();
      setPropertyVal(initialPropertyState);
      setIsUpdateActive(false);
    } catch (err) {
      setOpen(false);
      console.log(err.response.data);
      toast.error(err.response.data);
    }
  };
  
  const deleteFileHandler = async (id,docType) => {
    const propertyData = window.confirm("Do you want to Delete the Property Insurance Data?");
    if (propertyData) {
      setOpen(true);
      const request = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loanId: loanId,
        srNo: id,
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        docType:docType
      };

      try {
        const { data } = await axios.post(url + "/loan/delete/property/data", request);

        if (data.auth === true) {
          setOpen(false);
          toast.success(data.message);
        } else {
          setOpen(false);
          toast.error(data.message);
        }
        await fetchData();
        setPropertyVal(initialPropertyState);
      } catch (error) {
        setOpen(false);
        console.log(error.response.data);
        toast.error(error.response.data.message);
      }
    }
    else {
      setOpen(false);
      toast.error("Permission Denied by the user.");
    }
  };
  
  const editFileHandler = async (field) => {
    console.log(field);
    setIsUpdateActive(true);
    setPropertyVal({
      srNo: field.srNo,
      propertyNumber: field.propertyNumber,
      sumAssured: field.sumAssured,
      policyNumber: field.policyNumber,
      propertyAddress: field.propertyAddress,
      imageFormat: field.propertyDocType,
      imageBase64: field.chequeData,
    });
  };
  
  const handleViewImage = (format, base64) => {
    if (format === "pdf") {
      setPdfModal(true);
    } else {
      setDocModal(true);
    }
    setDocModalProps((prevState) => ({
      ...prevState,
      doc: base64,
      format: format,
    }));
  };

  const closeDocModal = () => {
    setDocModal(false);
  };

  const downloadFileHandler = (format, base64) => {
    let type;
    if (format === "pdf") {
      type = "pdf";
    } else {
      type = "image";
    }

    const linkSource = `data:${type}/${format};base64,${base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${loanId}_Property_Insurance.${format}`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <section>
      <div className={styles.pdcModal}>
        <div className={styles.pdcModalOverlay}>
          <div className={styles.pdcModalContent}>
            {docModal && (
              <SingleDocModal
                closeModal={closeDocModal}
                doc={docModalProps.doc}
                docType={docModalProps.format}
              />
            )}
            {pdfModal && (
              <PdfInsurance
                url={`data:application/pdf;base64,${docModalProps.doc}`}
                closeModal={() => setPdfModal(false)}
                docType={docModalProps.format}
              />
            )}
            <div className={styles.topBar}>
              <div>
                <h2>Property Insurance Details</h2>
              </div>

              <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            </div>
            <div className={styles.tableDiv}>
              <table className={styles.customTable}>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Property Number</th>
                    <th>Sum Assured</th>
                    <th>Policy Number</th>
                    <th>Property Address</th>
                    <th>Upload Policy Document</th>
                    <th>Actions</th>
                  </tr>
                  {propertyArr?.length > 0
                    ? propertyArr.map((field) => {
                        return (
                          <tr key={field.srNo}>
                            <td>{field.srNo}</td>
                            <td>{field.propertyNumber}</td>
                            <td>{field.sumAssured}</td>
                            <td>{field.policyNumber}</td>
                            <td>{field.propertyAddress}</td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <p
                                  onClick={() =>
                                    handleViewImage(
                                      field.propertyDocType,
                                      field.chequeData
                                    )
                                  }
                                >
                                  <FaImage
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                                <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.propertyDocType,
                                      field.chequeData
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                                </Tooltip>
                              </div>
                            </td>
                            <td>
                              <div className={styles.actions}>
                              <Tooltip title="Delete">
                              <p onClick={() => deleteFileHandler(field.srNo,field.propertyDocType)}>
                                <MdDeleteForever
                                  size={24}
                                  color="red"
                                  cursor={"pointer"}
                                />
                              </p>
                              </Tooltip>
                              <Tooltip title="Edit">
                              <p onClick={() => editFileHandler(field)}>
                                <EditIcon
                                  size={24}
                                  color="gray"
                                  cursor={"pointer"}
                                />
                              </p>
                              </Tooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                  <tr>
                    <td>{isUpdateActive===true? propertyVal.srNo:propertyCount}</td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="number"
                        value={propertyVal.propertyNumber}
                        onChange={handleInputChange("propertyNumber")}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className={styles.inputStyle}
                        value={propertyVal.sumAssured}
                        onChange={handleInputChange("sumAssured")}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.inputStyle}
                        value={propertyVal.policyNumber}
                        onChange={handleInputChange("policyNumber")}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={styles.inputStyle}
                        onChange={handleInputChange("propertyAddress")}
                        value={propertyVal.propertyAddress}
                      />
                    </td>
                    <td>
                      <input
                        onChange={handleImageUpload}
                        type="file"
                        ref={uploadRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => uploadRef.current.click()}
                      >
                        {isUpdateActive === true?"Upload New Doc":"Upload"}
                      </button>
                    </td>
                    <td>
                      <button className={styles.add} onClick={addFieldHandler}>
                        {isUpdateActive === true?"Update":"ADD"}
                      </button>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
    </section>
  );
};

export default PropertyModal;

